import React from "react";
import "./Skeleton.css";

/**
 * Skeleton loader component for showing loading states
 * @param {Object} props - Component props
 * @param {string} props.width - Width of the skeleton (default: '100%')
 * @param {string} props.height - Height of the skeleton (default: '20px')
 * @param {string} props.borderRadius - Border radius (default: '4px')
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {string} props.variant - Preset variant ('input', 'button', 'text', 'circle', 'custom')
 */
const Skeleton = ({
  width = "100%",
  height = "20px",
  borderRadius = "4px",
  className = "",
  style = {},
  variant = "custom",
}) => {
  // Preset variants
  const variants = {
    input: { height: "38px", borderRadius: "4px" },
    button: { height: "38px", borderRadius: "4px" },
    text: { height: "20px", borderRadius: "4px" },
    circle: { borderRadius: "50%" },
    custom: {},
  };

  const variantStyles = variants[variant] || variants.custom;

  const skeletonStyle = {
    width,
    height: variantStyles.height || height,
    borderRadius: variantStyles.borderRadius || borderRadius,
    ...style,
  };

  return (
    <div
      className={`skeleton-loader ${className}`}
      style={skeletonStyle}
    ></div>
  );
};

export default Skeleton;

